<template>
    <div class="application" :theme="theme">
        <router-view />
    </div>
</template>

<script>
    export default {
        name: 'Application',
        computed: {
            theme(){
                return this.$store.state.theme.active;
            }
        },
        created(){
            // If there is not currently an active product, try to activate one.
            if(this.$route.params.product){
                // Find any product this user has access to (there may be none).
                const product = this.$store.getters.products.find(product => product.product_slug === this.$route.params.product);

                if(product){
                    // Activate the product that is specified in the URL.
                    // For example: https://learn.simcur.com/library/anatomy will activate `anatomy`.
                    this.$store.dispatch('products/activate', product);
                }
            }
        }
    }
</script>

<style lang="less">
    @import "~@/assets/less/variables";
    @import "~@/assets/less/global";
    @import "~@/assets/less/themes";

    .application
    {
        background: var(--background-color);
        min-height: 100vh;
    }

    .downtime-ribbon
    {
        height: 48px;
        background: @red;
        color: var(--primary-text-color);
        font-weight: 500;
        font-size: 14px;

        .constrain
        {
            height: 100%;
        }

        .text-button.border
        {
            font-size: 12px;
            padding: 2px 10px;
            margin-left: 10px;

            &:hover, &:active
            {
                background: transparent;
            }
        }
    }
</style>
